export const SCROLL_Y_TO_TRACK_OPACITY = 600;
